import { EnumDropdownItemVariant, type IDropdownItem } from 'shared/ui'
import { LINK_SMART_INBOXES } from 'shared/constants/links'
import { type Inbox } from 'entities/Inbox/model/Inbox'
import { getSmartOptionLabel } from 'entities/SendFrom'
import { type ISendFromStoreItem } from 'widgets/SendFrom/store/type'
import { SendFromScaleLabel } from 'widgets/SendFrom/ui/SendFromScaleLabel/SendFromScaleLabel'

export const getSendingOptionItems = (
  inbox: Inbox,
  options?: { disabledClosedTooltip?: true }
): IDropdownItem<ISendFromStoreItem>[] =>
  inbox.sendingOptions.map(({ key, number_ids }) => {
    const disabledClosedTooltip = options?.disabledClosedTooltip
    const label = getSmartOptionLabel(key)

    const tooltipLabel =
      (key === 'scaler' && (
        <>
          Sends messages from all your inbox numbers to balance the load <br />
          <a href={LINK_SMART_INBOXES} target='_blank' rel='noreferrer'>
            Learn more
          </a>
        </>
      )) ||
      (key === 'local_presence' && (
        <>
          Sends messages from local numbers by geographic proximity <br />
          <a href={LINK_SMART_INBOXES} target='_blank' rel='noreferrer'>
            Learn more
          </a>
        </>
      ))

    const labelContent =
      (key === 'scaler' && <SendFromScaleLabel />) || (key === 'local_presence' && 'Local presence')
    return {
      id: `${inbox.id}_${key}`,
      disabledClosedTooltip,
      label: label,
      labelContent: labelContent,
      searchPattern: getSmartOptionLabel(key),
      labelRight: `${number_ids.length} numbers`,
      data: {
        inbox,
        smart_option: key,
        smart_option_label: getSmartOptionLabel(key),
        searchPattern: '',
        parentIcon: inbox.icon,
        parentLabel: inbox.name,
      },
      tooltipQuestionProps: {
        margin: '10px',
        width: 155,
        type: 'description',
        placement: 'right',
        label: tooltipLabel,
      },
      iconQuestionProps: {
        fontSize: 13,
      },
      variant: EnumDropdownItemVariant.CheckedLeft,
      noRenderEmptyActiveValue: true,
    }
  })
